import {Button} from "reactstrap";
import React, {useState} from "react";
import {useDeleteErrorKey} from "./hooks/useDeleteErrorKey";

interface ErrorKeyItemRemoveProps {
    id: number;
    value: string;
}

const ErrorKeyItemRemove: React.FC<ErrorKeyItemRemoveProps> = ({id, value}) => {
    const [sureToRemove, setSureToRemove] = useState<boolean>(false);

    const {mutate: deleteErrorKey} = useDeleteErrorKey();

    const handleRemoveClick = () => {
        if (!sureToRemove) {
            setSureToRemove(true)
        } else {
            setSureToRemove(false)
            deleteErrorKey(id)
        }
    }

    return <Button color="danger" type="button" onClick={handleRemoveClick}>
        {sureToRemove ? "Confirm Removing" : value}
    </Button>
}

export default ErrorKeyItemRemove;